import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const communication_sent = ({ event: { kind, data: { recipients, message } } }) =>
  <div className={kind}>
    Communication sent to customer at: {recipients}.
    <br />
    Message Content: {message}
  </div>;


communication_sent.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      recipients: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication_sent.jsx